export default {
  changesCount: state => (state.summary ? state.summary.count : 0),
  changesFacilitiesCount: state =>
    state.summary ? state.summary.facilities_count : 0,
  changesIds: state => (state.summary ? state.summary.ids || [] : []),
  changesFields: state => (state.summary ? state.summary.fields : [])
};
